import { getIdToken } from "firebase/auth";
import { fbAuth } from "../services/firebaseService/connection";
import logger from "../utils/logger";
import { useEffect, useState, useCallback, useRef } from "react";

const useToken = () => {
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const isMounted = useRef(true);

  const getCurrentUserToken = useCallback(async (forceRefresh = false) => {
    if (!fbAuth.currentUser) {
      if (isMounted.current) {
        setError(new Error("No authenticated user"));
        setLoading(false);
      }
      return null;
    }

    try {
      setLoading(true);
      setError(null);

      const newToken = await getIdToken(fbAuth.currentUser, forceRefresh);

      if (isMounted.current) {
        setToken(newToken);
        setLoading(false);
      }

      return newToken;
    } catch (err) {
      logger.error("Failed to get token: ", err);
      if (isMounted.current) {
        setError(err);
        setLoading(false);
      }
      return null;
    }
  }, []);

  useEffect(() => {
    isMounted.current = true;
    getCurrentUserToken();

    return () => {
      isMounted.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    token,
    loading,
    error,
    refreshToken: () => getCurrentUserToken(true),
  };
};

export default useToken;
